import React from 'react';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Link } from '@uhg-abyss/web/ui/Link';

export type ReferralFormConsentTextProps = {
  vendor: 'findhelp' | 'uniteus';
  acceptsReferrals: boolean;
};

export const ReferralFormConsentText = ({
  vendor,
  acceptsReferrals,
}: ReferralFormConsentTextProps) => {
  return (
    <React.Fragment>
      {vendor === 'uniteus' ? (
        <div>
          <Text>
            <strong>Consent to Participate in the Unite Us Network</strong>
          </Text>
          <br />
          <br />
          <Text>
            By consenting, you agree to share information with a Network of
            health and social service partners powered by Unite Us software.
            This Network is made up of entities and individuals who are directly
            involved in your care or payment of care. Your personal information
            may be shared securely on the Network in accordance with privacy
            laws to connect you with services.
            <br />
            <br />
            This consent covers all information shared by you or by anyone that
            has the right to share information on your behalf and is relevant to
            the recipient's involvement in your care or payment for your care.
            You can always limit the information you provide on the Network by
            requesting to have it removed.
            <br />
            <br />
            To understand how your information may be used and kept safe on the
              Network, please see{' '}
              <Link
                href={'https://uniteus.com/privacy'}
                target="_blank"
                rel="noopener noreferrer"
              >
                uniteus.com/privacy
              </Link>.
            <br />
            If you no longer want your information shared on the Network, you
            can email <strong>consent@uniteus.com</strong> or ask any Network
            partner.
            <br />
            <br />
            <strong>Notes:</strong>
          </Text>
          <ul style={{ marginLeft: '20px', marginTop: '8px', listStyleType: 'disc' }}>
            <li>
              <Text>
                The "Refer" button will be grayed and not active until "Confirm
                consent" is checked
              </Text>
            </li>
            <li>
              <Text>
                "Refer" button will move to active state once "Confirm consent"
                is checked
              </Text>
            </li>
          </ul>
        </div>
      ) : (
        <div>
          <Text>
            I have verbal consent from the member (or the member’s personal
            representative) to:
          </Text>

          {vendor === 'findhelp' &&
            (acceptsReferrals ? (
              <FindhelpAcceptsReferralsConsentText />
            ) : (
              <FindhelpLogReferralConsentText />
            ))}
        </div>
      )}
    </React.Fragment>
  );
};

export const AdditonalInfoTextForLogReferral = () => {
  return (
    <React.Fragment>
      <div style={{ padding: '1rem' }}>
        <Text>
          This CBO does not accept referrals in the platform. Submit this referral form to contribute to our referral program and enable essential follow-up actions to support the member. When logging a referral, member information is not sent to the organization. Instead, share the organization's details with the member so the member can contact the organization.
        </Text>
      </div>
    </React.Fragment>
  );
};

/**
 * Program that actually receives information about referrals made in our system,
 *  so that the program themselves can follow up with the member.
 */
const FindhelpAcceptsReferralsConsentText = () => {
  return (
    <ul
      style={{
        listStyle: 'circle',
        marginLeft: '16px',
        marginTop: '4px',
      }}
    >
      <li>
        <Text>
          If email/text is selected as the "Best Way to Reach Them", send the
          member "Next Steps" to contact this organization.
        </Text>
      </li>

      <li>
        <Text>
          Send Member's name, identified social need(s), contact information,
          and any call notes to the selected organization through this system
          (findhelp) as documented in the form above.
        </Text>
      </li>

      <li>
        <Text>
          Notify the selected organization to reach out to the member via the
          "Best way to Reach Them".
        </Text>
      </li>

      <li>
        <Text>
          Record these referral details in the system, so that UHC can follow up
          with the member.
        </Text>
      </li>
    </ul>
  );
};

/**
 * Program that does not receive referral records -- Instead the advocate will provide the member
 *  with the "Next Steps" instructions for the member to contact the program themselves.
 */
const FindhelpLogReferralConsentText = () => {
  return (
    <ul
      style={{
        listStyle: 'circle',
        marginLeft: '16px',
        marginTop: '4px',
      }}
    >
      <li>
        <Text>
          Record these referral details along with Member’s name, identified
          social need(s), contact information, and any call notes in the system,
          so that UHC can follow up with the member.
        </Text>
      </li>
    </ul>
  );
};
